export default{
    feedback(state){
        return state.feedback;
    },
    hasFeedback(state){
        return state.feedback && state.feedback.length;
    }
}